<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        :fill-color="color"
        @click="$emit('click')"
    >
        <path
            d="M16.5,14c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h3c0.276,0,0.5-0.224,0.5-0.5v-2c0-0.276,0.224-0.5,0.5-0.5h2
		c0.276,0,0.5-0.224,0.5-0.5v-3C23,6.224,22.776,6,22.5,6h-2C20.224,6,20,5.776,20,5.5v-2C20,3.224,19.776,3,19.5,3h-18
		C1.224,3,1,3.224,1,3.5v9C1,12.776,1.224,13,1.5,13h3C4.776,13,5,13.224,5,13.5S4.776,14,4.5,14h-3C0.673,14,0,13.327,0,12.5v-9
		C0,2.673,0.673,2,1.5,2h18C20.327,2,21,2.673,21,3.5V5h1.5C23.327,5,24,5.673,24,6.5v3c0,0.827-0.673,1.5-1.5,1.5H21v1.5
		c0,0.827-0.673,1.5-1.5,1.5H16.5z"
        />
        <path
            d="M10.5,22c-0.276,0-0.5-0.224-0.5-0.5V18H9.5C7.57,18,6,16.43,6,14.5v-3C6,10.673,6.673,10,7.5,10H8V6.5
		C8,6.224,8.224,6,8.5,6S9,6.224,9,6.5V10h3V6.5C12,6.224,12.224,6,12.5,6C12.776,6,13,6.224,13,6.5V10h0.5
		c0.827,0,1.5,0.673,1.5,1.5v3c0,1.93-1.57,3.5-3.5,3.5H11v3.5C11,21.776,10.776,22,10.5,22z M7.5,11C7.224,11,7,11.224,7,11.5v3
		C7,15.878,8.121,17,9.5,17h2c1.378,0,2.5-1.122,2.5-2.5v-3c0-0.276-0.224-0.5-0.5-0.5H7.5z"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'BatteryPlugIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>
